var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(true)?_c('div',{staticClass:"container home"},[_c('imgGenForm')],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }